import { Body2, Box, Button, ButtonGroup, Flex } from '@sainsburys-tech/fable'
import { AlertCircleFilled } from '@sainsburys-tech/icons'
import React, { useEffect } from 'react'

import parseErrorStack from '../../utils/errors'
import Loading from './Loading'
interface IError<T> {
  testid?: string
  message: string
  actions?: [
    {
      handler: () => T
      title: string
    },
  ]
}

const onReload = () => {
  window.location.href = window.location.origin
}

function ErrorRefresh<T>({ message, actions, testid }: IError<T>) {
  useEffect(() => {
    const errorStack = parseErrorStack(new Error(message))
    if (errorStack && errorStack.length > 0) {
      console.log(message, JSON.stringify(errorStack, null, 2))
    }
  }, [message, actions])

  return (
    <>
      <Box as='div' style={{ width: '100%' }} data-testid={testid}>
        <Flex
          testId='errorRefresh'
          direction='column'
          alignItems='center'
          gap='lg'
          style={{ minHeight: 'calc(100vh - 56px)' }}
        >
          <Box
            backgroundColor='secondary'
            padding={{ sm: 'md', md: 'lg' }}
            style={{
              maxWidth: 1200,
              width: '100%',
              marginTop: '2rem',
              boxSizing: 'border-box',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div>
              <AlertCircleFilled className='c-common-error_icon-larger' />

              <div className='c-common-error_primaryMessage'>
                <Body2>Something went wrong.</Body2>
              </div>

              <div className='c-common-error_secondaryMessage'>
                {message ? (
                  <div data-testid='errorMessage'>
                    <Body2>{message}</Body2>
                  </div>
                ) : (
                  <Loading />
                )}
              </div>

              <div
                className='c-common-error_secondaryMessage'
                style={{ paddingBottom: '12px' }}
              >
                <Body2>Please try again.</Body2>
              </div>

              <div>
                <ButtonGroup align='center' gap='lg'>
                  <Button onClick={() => onReload()}>Refresh</Button>
                  {actions &&
                    actions.length > 0 &&
                    actions.map((x, i) => (
                      <Button key={i} onClick={() => x.handler()}>
                        {x.title}
                      </Button>
                    ))}
                </ButtonGroup>
              </div>
            </div>
          </Box>
        </Flex>
      </Box>
    </>
  )
}

export default ErrorRefresh
